import moment from "moment";

export const clearAuthData = () => {
  localStorage.removeItem("login_gw");
  localStorage.removeItem("token_gw");
};

export const dayNumber = (i, d, data) => {
  let s = 0;
  for (let j = 0; j < i; j++) {
    s += Number(data?.destinationCityDetails[j]?.itineraryDatys?.length);
  }
  return s + d;
};

export const getSubscriptionStatus = (subscription, warningDays) => {
  if (!subscription) return { status: "inactive", daysRemaining: 0 };

  if (subscription?.amount === "0") {
    return { status: "free", daysRemaining: null };
  }
  if (subscription?.status === "active" || subscription?.status === "ACTIVE") {
    // const expiryDate = moment.unix(1732502222);
    const expiryDate = moment.unix(
      subscription?.current_period_end
    );
    const daysRemaining = expiryDate.diff(moment(), "days");

    if (daysRemaining > 0 && daysRemaining <= warningDays) {
      return { status: "warning", daysRemaining };
    } else if (daysRemaining > warningDays) {
      return { status: "active", daysRemaining };
    } else {
      return { status: "expired", daysRemaining: 0 };
    }
  }
  return { status: "inactive", daysRemaining: 0 };
};

export const getFirstDayAndLastDay = (array) => {
  if (!Array.isArray(array) || array.length === 0) {
    return {
      firstDate: null,
      lastDate: null,
    };
  }
  return {
    firstDate: array[0]?.date || null,
    lastDate: array[array.length - 1]?.date || null,
  };
};

export const calculateDuration = (fromDate, toDate) => {
  const fromMoment = moment(fromDate);
  const toMoment = moment(toDate);
  const duration = moment.duration(toMoment.diff(fromMoment));
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();
  if (minutes === 0) {
    return `${hours} h`;
  } else if (hours === 0) {
    return `${minutes} min`;
  } else {
    return `${hours} h ${minutes} min`;
  }
};

export const findCountryCity = (data) => {
  const countryCityMap = {};
  data.forEach((entry) => {
    const country = entry.destination_city?.country;
    const city = entry.destination_city?.city;

    if (country && city) {
      if (!countryCityMap[country]) {
        countryCityMap[country] = new Set();
      }
      countryCityMap[country].add(city);
    }
  });

  const result = Object.entries(countryCityMap).map(([country, cities]) => ({
    country,
    cities: Array.from(cities),
  }));

  return result;
};

export const timeFunc = (item) => {
  const outDate =
    item?.days_type == "Stays"
      ? item.checkOutDate
      : item?.days_type == "Tours"
        ? item.checkOutTime
        : item.to_date;

  return moment(outDate).format("HH:mm");
};

export const collectIcons = (data) => {
  // console.log("collectIcons===>", data);
  const imagesArr = [];

  // Define regex to match valid image formats
  const imageExtensions = /\.(jpeg|jpg|gif|png|webp|svg|bmp|tiff|ico|heic|avif)$/i;

  data.forEach((distitem) => {
    distitem?.itineraryDatys?.forEach((daysitem) => {
      // console.log("daysitem===>", daysitem);
      daysitem?.itineraryDaysDetails?.forEach((dtitem) => {
        if (Array.isArray(dtitem?.icon) && dtitem.icon.length > 0) {
          // Filter only valid image URLs
          const validImages = dtitem.icon.filter((icon) =>
            typeof icon === "string" && imageExtensions.test(icon)
          );

          if (validImages.length > 0) {
            imagesArr.push(...validImages);
          }
        }
      });
    });
  });

  return imagesArr;
};

export const totalItineraryDaysDetailsCount = (item) => {
  return item?.destinationCityDetails?.reduce(
    (citySum, cityItem) =>
      citySum +
      (cityItem?.itineraryDatys?.reduce(
        (daySum, dayItem) => daySum + (dayItem?.itineraryDaysDetails?.length || 0),
        0
      ) || 0),
    0
  ) || 0;
};

export const findMinMaxAmount = (data) => {
  const maxAmount = data.reduce((max, item) => {
    const newAmount = item?.estimated_Cost;
    if (newAmount != null && newAmount !== 0) {
      return Math.max(max, newAmount);
    }
    return max;
  }, -Infinity);

  return maxAmount === -Infinity ? 10000 : Math.ceil(maxAmount);
};

export const extractLocationData = (place) => {
  let city = "",
    country = "",
    iso_code = "",
    lat = "",
    lng = "";

  if (!place || !place.address_components) return { city, country, iso_code, lat, lng };
  place.address_components.forEach((component) => {
    if (component.types.includes("locality")) {
      city = component.long_name;
    }
    if (component.types.includes("country")) {
      country = component.long_name;
      iso_code = component.short_name;
    }
  });
  if (place.geometry && place.geometry.location) {
    lat = place.geometry.location.lat();
    lng = place.geometry.location.lng();
  }
  return { city, country, iso_code, lat, lng, address: `${city}, ${country}` };
};

export const getPaymentStatus = (status) => {
  const completedStatuses = ["COMPLETED", "paid"];
  const canceledStatuses = ["CANCELED", "void"];
  const pendingStatuses = ["PENDING", "open"];
  const failedStatuses = ["FAILED", "unpaid"];

  if (completedStatuses.includes(status)) return "Completed";
  if (canceledStatuses.includes(status)) return "Canceled";
  if (pendingStatuses.includes(status)) return "Pending";
  if (failedStatuses.includes(status)) return "Failed";
  return;
};